export default __webpack_public_path__ + "static/media/Medical & Healthcare 2.16860daa.jpg";